@if (notification().unit) {
  @let number = notification().number || '-';
  @let unit = notification().unit || '-';
  @let prefix = notification().timing === 'before' ? '-' : '';
  <span class="d-flex flex-row gap-1">
    <span>
      {{ prefix }} {{ number }}
      {{ '' | pharTransformTimeUnit: unit : '' : '' : true : number }}
    </span>
    <span>
      @switch (notification().timing) {
        @case ('before') {
          {{ 'STUDY.EVENTS.NOTIFICATIONS.BEFORE_EVENT_COLON' | translate }}
        }
        @case ('after') {
          {{ 'STUDY.EVENTS.NOTIFICATIONS.AFTER_EVENT_COLON' | translate }}
        }
      }
    </span>
    <span class="specific-time"> {{ notification().sendTime || '-' }} </span>
  </span>
} @else {
  <span class="d-flex flex-row">
    <span>
      {{ 'STUDY.EVENTS.NOTIFICATIONS.EVENT_DAY_COLON' | translate }}
    </span>
    <span class="specific-time"> {{ notification().sendTime || '-' }}</span>
  </span>
}
